/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css"; // Importa o CSS do calendÃ¡rio
import '../css/dashboard.css';
import '../css/danfe.css';
import logo from '../images/logo_fundo_branco.png';
import DanfeService from '../../modules/services/DanfeService';
import { GoChevronDown, GoChevronUp, } from "react-icons/go";
import { FaChevronLeft, FaChevronRight, FaChevronDown } from 'react-icons/fa';
import { FiDownload } from "react-icons/fi";
import { useLocation } from "react-router-dom";
import { ptBR } from "date-fns/locale";
import { formatCNPJ } from '../../utils/format';

const getNfeLinkClass = (tipo) => {
    if (tipo === 'B') return 'nfe-link nfe-link-complementar';
    return 'nfe-link nfe-link-venda';
};

const formatarDataEmissao = (data) => {
    if (!data) return '-';
    if (data.includes('/')) return data;
    const [datePart] = data.split(' ');
    const [year, month, day] = datePart.split('-');
    return `${day}/${month}/${year}`;
};

const formatarValor = (valor) =>
    valor != null
        ? `R$ ${valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`
        : 'R$ 0,00';

const getChaveConsultaReferencia = (danfe) =>
    danfe.dsChaveNfeReferencia || danfe.dsChaveNfe || danfe.dsChave || null;

const getChaveCacheReferencia = (danfe) =>
    danfe.dsChaveNfe || danfe.dsChaveNfeReferencia || `${danfe.nrNfe}-${danfe.nrSerieNfe}`;

const getSerieReferencia = (referencia, danfe) => {
    if (referencia.nrSerieNfe != null) return referencia.nrSerieNfe;
    if (referencia.nrSerie != null) return referencia.nrSerie;
    const chave = danfe.dsChaveNfeReferencia;
    if (chave && chave.length >= 25) {
        return parseInt(chave.substring(22, 25), 10);
    }
    return 1;
};

function Danfe({ cliente }) {
    const codigoCliente = cliente.cdCliente;
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(true); // Estado para controlar o carregamento
    const [danfes, setDanfes] = useState([]);
    const [selectedDanfes, setSelectedDanfes] = useState([]);
    const [expandedRows, setExpandedRows] = useState([]);
    const [referenciaComplementar, setReferenciaComplementar] = useState({});
    const [loadingReferencia, setLoadingReferencia] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 15;
    const [valorBusca, setValorBusca] = useState('');

    const filtroAteXDias = [location.state?.vlNfeAte];


    // Inicializa filtros com a situaÃ§Ã£o padrÃ£o
    const [filtros, setFiltros] = useState({
        orderBy: "DT_EMISSAO",
        fatorOrdenacao: "DESC",
        vlNfeAte: filtroAteXDias.value,
        nrNfeIn: '',
        dtEmissaoDe: null,
        dtEmissaoAte: null,
        tipoIn: ['V', 'B'],
    });
    // FunÃ§Ã£o para buscar danfes com base nos filtros
    const fetchDanfesInfo = async () => {
        setIsLoading(true);
        console.log("filtros: ", filtros);
        const filtrosFormatados = {
            ...filtros,
            dtEmissaoDe: convertDateToString(filtros.dtEmissaoDe),
            dtEmissaoAte: convertDateToString(filtros.dtEmissaoAte)
        };
        console.log("filtrosFormatados Novo : ", filtrosFormatados);

        try {
            const response = await DanfeService.getListaNotasFiscais(codigoCliente, filtros);
            setDanfes(response || []);
        } catch (err) {
            console.error("Erro ao buscar danfes:", err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (location.state) {

            setFiltros((prevFiltros) => ({
                ...prevFiltros,
                vlNfeAte: location.state.vlNfeAte || prevFiltros.vlNfeAte,
                dtEmissaoDe: location.state.dtEmissaoDe || prevFiltros.dtEmissaoDe, // Adicionando o filtro de data de emissão de
                dtEmissaoAte: location.state.dtEmissaoAte || prevFiltros.dtEmissaoAte // Adicionando o filtro de data de emissão até
            }));
        }
    }, [location.state]);

    useEffect(() => {
        fetchDanfesInfo();
    }, [filtros]); // A dependência agora inclui os filtros



    // FunÃ§Ã£o para atualizar o valor de Nota Fiscal
    const handleNfeChange = (event) => {
        let nrNfe = event.target.value.replace(/[^0-9]/g, ""); // Remove tudo que não for número
        setFiltros(prevFiltros => ({
            ...prevFiltros,
            nrNfeIn: nrNfe // Atualiza o filtro com o número da NF
        }));
    };

    const handleValorChange = (event) => {
        const valorDigitado = event.target.value;
        setValorBusca(valorDigitado); // Mantém o valor digitado no input

        let vlNfe = valorDigitado.replace(/[^0-9.,]/g, "");
        vlNfe = vlNfe.replace(",", ".");
        const valor = parseFloat(vlNfe);
        if (!isNaN(valor)) {
            setFiltros(prevFiltros => ({
                ...prevFiltros,
                vlNfeDe: valor - 1,
                vlNfeAte: valor + 1
            }));
        } else {
            setFiltros(prevFiltros => ({
                ...prevFiltros,
                vlNfeDe: null,
                vlNfeAte: null
            }));
        }
    };

    const handleDateChange = (date, field) => {
        //console.log("Campo:", field, "Data selecionada:", date);
        if (date) {
            //console.log("Entrou", date);
            setFiltros((prevFiltros) => ({
                ...prevFiltros,
                [field]: date, // Armazene o objeto Date
            }));
        } else {
            //console.log("NÃo Entrou", date);
            setFiltros((prevFiltros) => ({
                ...prevFiltros,
                [field]: null,
            }));
        }
    };



    // FunÃ§Ãµes de manipulaÃ§Ã£o de seleÃ§Ã£o e download de danfes (mantidas inalteradas)
    const handleSelectDanfe = (index) => {
        setSelectedDanfes(prevSelected =>
            prevSelected.includes(index)
                ? prevSelected.filter(item => item !== index)
                : [...prevSelected, index]
        );
    };

    const handleSelectAllDanfes = (event) => {
        setSelectedDanfes(event.target.checked ? danfes.map((_, index) => index) : []);
    };

    const visualizarDanfe = async (danfe) => {
        //console.log("clicou para abrir o modal exibindo a nota")
        setIsModalLoading(true);
        setModalContent('');
        setIsModalOpen(true);

        try {
            const blob = await DanfeService.getVisualizarNotaFiscal(codigoCliente, danfe.nrNfe, danfe.nrSerieNfe);
            const url = URL.createObjectURL(blob);
            setModalContent(url);
        } catch (error) {
            console.error("Erro ao visualizar o boleto:", error);
            alert("Erro ao carregar o boleto.");
        } finally {
            setIsModalLoading(false); // Finaliza o carregamento quando o conteúdo estiver pronto
            setIsModalOpen(true); // Abre o modal
        }
    };



    const closeModal = () => {
        setIsModalOpen(false);
        setModalContent('');
        if (modalContent) {
            URL.revokeObjectURL(modalContent);
        }
    };

    const baixardanfesSelecionados = async () => {
        if (selectedDanfes.length === 0) {
            alert("Selecione pelo menos uma NFE para baixar.");
            return;
        }
        try {
            for (const index of selectedDanfes) {
                const danfe = danfes[index];
                const blob = await DanfeService.getVisualizarNotaFiscal(codigoCliente, danfe.nrNfe, danfe.nrSerieNfe);
                const url = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.download = `${danfe.nrNfe}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.error("Erro ao baixar os danfes:", error);
            alert("Erro ao baixar os danfes.");
        }
    };

    const baixarXmlSelecionados = async () => {
    console.log("Iniciando o processo de download de XMLs...");
    
    if (selectedDanfes.length === 0) {
        alert("Selecione pelo menos um XML para baixar.");
        console.warn("Nenhum XML selecionado.");
        return;
    }

    try {
        for (const index of selectedDanfes) {
            const danfe = danfes[index];
            console.log(`Processando DANFE de �ndice ${index}:`, danfe);

            const ano = danfe.dtEmissao.split('/')[2]; // assume formato DD/MM/YYYY
            const url = `https://arquivos.portalrelacionamento.dev-gam.com/nfe-xml/${ano}/${danfe.empresa}_${danfe.nrSerieNfe}_${danfe.nrNfe}.xml`;

            console.log(`URL de download gerada: ${url}`);

            // Faz o fetch do XML da URL externa
            const response = await fetch(url);
            console.log(`Resposta do fetch para ${danfe.nrNfe}:`, response);

            if (!response.ok) {
                console.error(`Erro ao baixar o XML da nota ${danfe.nrNfe}: Status ${response.status}`);
                continue; // continua com os pr�ximos, em vez de parar tudo
            }

            const xmlBlob = await response.blob();
            const blobUrl = URL.createObjectURL(xmlBlob);
            console.log(`Blob URL criado: ${blobUrl}`);

            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = `${danfe.nrNfe}.xml`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            console.log(`Download disparado para: ${danfe.nrNfe}.xml`);

            URL.revokeObjectURL(blobUrl);
        }

        console.log("Processo de download finalizado.");
    } catch (error) {
        console.error("Erro ao baixar os XMLs:", error);
        alert("Erro ao baixar os XMLs.");
    }
    };

    const toggleRow = async (index, danfe) => {
        if (danfe.tipo !== 'B') return;

        const isExpanded = expandedRows.includes(index);
        if (isExpanded) {
            setExpandedRows(prevExpanded => prevExpanded.filter(i => i !== index));
            return;
        }

        setExpandedRows(prevExpanded => [...prevExpanded, index]);

        const chaveConsulta = getChaveConsultaReferencia(danfe);
        const chaveCache = getChaveCacheReferencia(danfe);
        if (!chaveConsulta || referenciaComplementar[chaveCache]) return;

        setLoadingReferencia(prev => ({ ...prev, [index]: true }));
        try {
            const data = await DanfeService.consultarReferenciaComplementar(codigoCliente, chaveConsulta);
            setReferenciaComplementar(prev => ({ ...prev, [chaveCache]: data }));
        } catch (err) {
            console.error("Erro ao buscar nota de venda referenciada:", err);
            setReferenciaComplementar(prev => ({ ...prev, [chaveCache]: { error: true } }));
        } finally {
            setLoadingReferencia(prev => ({ ...prev, [index]: false }));
        }
    };

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = danfes.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(danfes.length / recordsPerPage);

    const goToPage = (page) => setCurrentPage(page);

    const handleOpenDateModal = () => setShowDateModal(true);
    const handleCloseDateModal = () => setShowDateModal(false);
    const [showDateModal, setShowDateModal] = useState(false);

    const applyDateFilter = () => {
        fetchDanfesInfo();
        handleCloseDateModal();
    };

    const convertDateToString = (date) => {
        // Verifica se é um objeto Date válido
        if (date instanceof Date && !isNaN(date)) {
            // Formata a data para "YYYY-MM-DDT00:00"
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Adiciona zero à esquerda
            const day = date.getDate().toString().padStart(2, "0"); // Adiciona zero à esquerda

            // Retorna o formato desejado
            return `${year}-${month}-${day}T24:00:00.000Z`;
        }
        return null; // Caso a data seja inválida

    };

    const clearDateFilter = (fieldStart, fieldEnd) => {
        setFiltros((prevFiltros) => ({
            ...prevFiltros,
            [fieldStart]: null,
            [fieldEnd]: null,
        }));
        handleCloseDateModal();
    };

    const [isModalLoading, setIsModalLoading] = useState(true); // Novo estado para controle do carregamento no modal

    const handleSort = (column) => {
        const isAsc = filtros.orderBy === column && filtros.fatorOrdenacao === 'ASC';
        setFiltros({
            ...filtros,
            orderBy: column,
            fatorOrdenacao: isAsc ? 'DESC' : 'ASC',
        });
    };

    return (
        <div className="dashboard">
            <div className="dashboard-content">
                <div className="dashboard-painel danfes-painel">
                    <h3 className='titulo'>Danfes</h3>
                    <div className='topo-desc'>
                        <p className='texto'>Todas as suas Danfes e XMLs.</p>
                        <div className='topo-botoes'>
                            <button className="download-btn" onClick={baixardanfesSelecionados}>
                                <FiDownload /> Baixar Danfes ({selectedDanfes.length})
                            </button>
                            <span> </span>
                            <button className="download-btn" onClick={baixarXmlSelecionados}>
                                <FiDownload /> Baixar XMLs ({selectedDanfes.length})
                            </button>
                        </div>
                    </div>
                    <div className="danfes-filtros">
                        <input
                            type="text"
                            placeholder="Nfe"
                            className="input-filtro"
                            value={filtros.nrNfeIn}
                            onChange={handleNfeChange}
                        />
                        <button onClick={handleOpenDateModal} className="input-filtro filtro-data-btn">
                            Data de Emissão <FaChevronDown />
                            {(filtros.dtEmissaoDe || filtros.dtEmissaoAte) && <span className="filtro-ativo-indicador"></span>}
                        </button>
                        <input
                            type="text"
                            placeholder="Valor"
                            value={valorBusca}
                            onChange={handleValorChange}
                            className="input-filtro"
                        />

                    </div>
                    <div className="danfe-legenda">
                        <span className="danfe-legenda-item">
                            <span className="danfe-legenda-cor nfe-link-venda" aria-hidden="true">●</span>
                            Operação Venda
                        </span>
                        <span className="danfe-legenda-item">
                            <span className="danfe-legenda-cor nfe-link-complementar" aria-hidden="true">●</span>
                            Operação Complementar
                        </span>
                    </div>
                    {isLoading ? (
                        <div className="loading-container">
                            <img src={logo} alt="GAM" className="loading-logo" />
                            <div className="spinner"></div>
                            <p>Carregando lista de Danfes...</p>
                        </div>
                    ) : (
                        <div className="danfes-lista">
                            {danfes.length === 0 ? (
                                <p className="mensagem-vazia">Sem informações no momento para os parâmetros informados.</p>
                            ) : (
                                <table className="danfes-tabela">
                                    <thead>
                                        <tr>
                                            <th>
                                                <input
                                                    type="checkbox"
                                                    onChange={handleSelectAllDanfes}
                                                    checked={selectedDanfes.length === danfes.length && danfes.length > 0}
                                                />
                                            </th>
                                            <th>CNPJ</th>
                                            <th>Nº NFE</th>
                                            <th>Série</th>
                                            <th className="sortable-header" onClick={() => handleSort('DT_EMISSAO')}>
                                                Emissão
                                                {filtros.orderBy === 'DT_EMISSAO' && (filtros.fatorOrdenacao === 'ASC' ? ' ▲' : ' ▼')}
                                            </th>
                                            <th className="sortable-header" onClick={() => handleSort('VL_NFE')}>
                                                Valor
                                                {filtros.orderBy === 'VL_NFE' && (filtros.fatorOrdenacao === 'ASC' ? ' ▲' : ' ▼')}
                                            </th>
                                            <th>Detalhes</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentRecords.map((danfe, index) => {
                                            const globalIndex = index + indexOfFirstRecord;
                                            const isComplementar = danfe.tipo === 'B';
                                            const isExpanded = expandedRows.includes(globalIndex);
                                            const referencia = referenciaComplementar[getChaveCacheReferencia(danfe)] || null;
                                            const isLoadingReferencia = loadingReferencia[globalIndex];

                                            return (
                                            <React.Fragment key={globalIndex}>
                                                <tr
                                                    onClick={() => isComplementar && toggleRow(globalIndex, danfe)}
                                                    className={`${isExpanded ? 'expanded' : ''} ${isComplementar ? 'row-complementar-expansivel' : ''}`}
                                                >
                                                    <td onClick={(e) => e.stopPropagation()}>
                                                        <input
                                                            type="checkbox"
                                                            onChange={() => handleSelectDanfe(globalIndex)}
                                                            checked={selectedDanfes.includes(globalIndex)}
                                                        />
                                                    </td>
                                                    <td>{formatCNPJ(danfe.cnpj)}</td>
                                                    <td>
                                                        <a href="#" className={getNfeLinkClass(danfe.tipo)} onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            visualizarDanfe(danfe);
                                                        }}>
                                                            {danfe.nrNfe}
                                                        </a>
                                                    </td>
                                                    <td>{danfe.nrSerieNfe}</td>
                                                    <td>{danfe.dtEmissao}</td>
                                                    <td>{formatarValor(danfe.vlNfe)}</td>
                                                    <td>
                                                        {isComplementar && (
                                                            <span className="toggle-details">
                                                                {isExpanded ? <GoChevronUp /> : <GoChevronDown />}
                                                            </span>
                                                        )}
                                                    </td>
                                                </tr>
                                                {isComplementar && isExpanded && (
                                                    <tr className="expanded">
                                                        <td colSpan="7">
                                                            <div className="expanded-details expanded-details-complementar">
                                                                {isLoadingReferencia ? (
                                                                    <p className="referencia-loading">Carregando nota de venda referenciada...</p>
                                                                ) : !getChaveConsultaReferencia(danfe) ? (
                                                                    <p className="referencia-erro">Chave da nota complementar não disponível.</p>
                                                                ) : referencia?.error ? (
                                                                    <p className="referencia-erro">Não foi possível carregar a nota de venda referenciada.</p>
                                                                ) : referencia ? (
                                                                    <table>
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Nº NFE - Série</th>
                                                                                <th>Emissão</th>
                                                                                <th>Valor</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>
                                                                                    <a
                                                                                        href="#"
                                                                                        className="nfe-link nfe-link-venda"
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault();
                                                                                            e.stopPropagation();
                                                                                            visualizarDanfe({
                                                                                                nrNfe: referencia.nrNfe,
                                                                                                nrSerieNfe: getSerieReferencia(referencia, danfe),
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        {referencia.nrNfe}
                                                                                    </a>
                                                                                    {' - '}
                                                                                    {getSerieReferencia(referencia, danfe)}
                                                                                </td>
                                                                                <td>{formatarDataEmissao(referencia.dtEmissao)}</td>
                                                                                <td>{formatarValor(referencia.vlNfe)}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                ) : (
                                                                    <p className="referencia-erro">Não foi possível carregar a nota de venda referenciada.</p>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </React.Fragment>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    )}
                    {/* Pagination controls */}
                    <div className="pagination">
                        <button
                            className="arrow-btn"
                            onClick={() => goToPage(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            <FaChevronLeft />
                        </button>

                        {Array.from({ length: totalPages }, (_, index) => (
                            <button
                                key={index}
                                onClick={() => goToPage(index + 1)}
                                className={`page-btn ${currentPage === index + 1 ? 'active' : ''}`}
                            >
                                {index + 1}
                            </button>
                        ))}

                        <button
                            className="arrow-btn"
                            onClick={() => goToPage(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >
                            <FaChevronRight />
                        </button>
                    </div>

                </div>
            </div>

            {isModalOpen && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="close-button" onClick={closeModal}>✖</button>
                        {isModalLoading ? (
                            <div className="loading-container" style={{ width: '100%', height: '500px', border: 'none' }}>
                                <div className="spinner"></div>
                                <p>Aguardando carregamento do PDF...</p>
                            </div>
                        ) : (
                            modalContent && (
                                <iframe
                                    src={modalContent}
                                    style={{ width: '100%', height: '500px', border: 'none' }}
                                    title="Danfe PDF"
                                />
                            )
                        )}
                    </div>
                </div>
            )}

            {/* Modal de Data */}
            {showDateModal && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h3>
                            Selecione o intervalo de datas de
                            emissão
                        </h3>
                        <div className="date-range-picker">
                            <DatePicker
                                selected={filtros.dtEmissaoDe}
                                onChange={(date) =>
                                    handleDateChange(
                                        date,
                                        "dtEmissaoDe"
                                    )
                                }
                                className="input-filtro"
                                placeholderText="Emissão De"
                                dateFormat="dd/MM/yyyy"
                                locale={ptBR}
                            />
                            <DatePicker
                                selected={filtros.dtEmissaoAte}
                                onChange={(date) => {
                                    handleDateChange(
                                        date,
                                        "dtEmissaoAte"
                                    );
                                }}
                                className="input-filtro"
                                placeholderText="Emissão Até"
                                dateFormat="dd/MM/yyyy"
                                locale={ptBR}
                            />
                        </div>
                        <div className="modal-buttons">
                            <button
                                className="download-btn"
                                onClick={applyDateFilter}
                            >
                                Aplicar
                            </button>
                            <button
                                className="download-btn"
                                onClick={() =>
                                    clearDateFilter(
                                        "dtEmissaoDe",
                                        "dtEmissaoAte"
                                    )
                                }
                            >
                                Limpar Filtro
                            </button>
                            <button
                                className="download-btn"
                                onClick={() => {
                                    clearDateFilter("dtEmissaoDe", "dtEmissaoAte");
                                    handleCloseDateModal();
                                }}
                            >
                                Cancelar
                            </button>{" "}
                            {/* Botão para fechar o modal */}
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}

export default Danfe;
